module.exports = __webpack_public_path__ + "1241074d743a0ec3ca0191a4227009a4.pdf";